export default function(ctx) {
var __t, __p = '';
__p += '<div class="chart-wrapper" data-chart-wrapper>\n	<div class="canvas-wrapper" data-canvas-wrapper>\n		<canvas data-canvas></canvas>\n	</div>\n</div>\n';
return __p
}